import { clsx } from "clsx";
import { FormEvent, useState } from "react";
import { useTranslation } from "react-i18next";

import { ApiError } from "@/api/rest/core/types";
import { ChangePasswordRequest } from "@/api/rest/models/auth";
import { changePassword } from "@/api/rest/services/authService";
import { BannerState } from "@/app/account/AccountPage.tsx";

export default function ChangePasswordForm({ className }: { className?: string }) {
  const { t } = useTranslation();
  const [passwordChangeResult, setPasswordChangeResult] = useState<BannerState | null>(null);

  const submitChangePassword = async (e: FormEvent<HTMLFormElement>) => {
    const form = e.currentTarget;
    setPasswordChangeResult(null);
    e.preventDefault();
    const data = Object.fromEntries(new FormData(form).entries()) as unknown as ChangePasswordRequest; // TODO: proper form validation
    if (!data.newPassword || data.newPassword !== data.confirmPassword) {
      setPasswordChangeResult({
        message: t("account.passwordsNotSame"),
        type: "error",
      });
      return;
    }
    try {
      const result = await changePassword(data);
      if (result) {
        setPasswordChangeResult({
          message: t("account.successfulPasswordChange"),
          type: "success",
        });
        form.reset();
      }
    } catch (e) {
      const error = e as ApiError;
      setPasswordChangeResult({ message: error.message, type: "error" });
    }
  };

  return (
    <form className={className} onSubmit={submitChangePassword}>
      <input
        className="border border-gray-300 rounded-md p-2"
        type="password"
        name="currentPassword"
        autoComplete="current-password"
        placeholder={t("account.currentPassword")}
        required
      />
      <input
        className="border border-gray-300 rounded-md p-2"
        type="password"
        name="newPassword"
        autoComplete="new-password"
        placeholder={t("account.newPassword")}
        required
      />
      <input
        className="border border-gray-300 rounded-md p-2"
        type="password"
        name="confirmPassword"
        autoComplete="new-password"
        placeholder={t("account.confirmNewPassword")}
        required
      />
      {passwordChangeResult && (
        <span
          className={clsx(
            `rounded-lg px-4 py-2 text-center`,
            passwordChangeResult.type === "success" ? `bg-green-300 text-green-900` : `bg-red-300 text-red-900`,
          )}
        >
          {passwordChangeResult.message}
        </span>
      )}
      {passwordChangeResult?.type !== "success" && (
        <button className="rounded-md p-2">{t("account.changePassword")}</button>
      )}
    </form>
  );
}
